/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateTicketSchema } from '../models/CreateTicketSchema';
import type { PagedTicketListSchema } from '../models/PagedTicketListSchema';
import type { TicketDetailSchema } from '../models/TicketDetailSchema';
import type { UpdateTicketSchema } from '../models/UpdateTicketSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TicketsApi {
    /**
     * Create Ticket
     * Create a new ticket. <br>Required Permission: create_ticket
     * @returns TicketDetailSchema Created
     * @throws ApiError
     */
    public static ticketsCreateTicketPost({
        requestBody,
    }: {
        requestBody: CreateTicketSchema,
    }): CancelablePromise<TicketDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/tickets/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Ticket List
     * Get list of company tickets. <br>Require permission: list_tickets
     * @returns PagedTicketListSchema OK
     * @throws ApiError
     */
    public static ticketsGetTicketListGet({
        orderBy,
        limit = 100,
        offset,
    }: {
        orderBy?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedTicketListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/tickets/',
            query: {
                'order_by': orderBy,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Get Ticket
     * Get ticket detail. <br>Required Permission: get_ticket_detail
     * @returns TicketDetailSchema OK
     * @throws ApiError
     */
    public static ticketsGetTicketGet({
        ticketId,
    }: {
        ticketId: string,
    }): CancelablePromise<TicketDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/tickets/{ticket_id}/',
            path: {
                'ticket_id': ticketId,
            },
        });
    }
    /**
     * Update Ticket
     * Update existing ticket. <br>Required Permission: update_ticket
     * @returns TicketDetailSchema OK
     * @throws ApiError
     */
    public static ticketsUpdateTicketPut({
        ticketId,
        requestBody,
    }: {
        ticketId: string,
        requestBody: UpdateTicketSchema,
    }): CancelablePromise<TicketDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/tickets/{ticket_id}/',
            path: {
                'ticket_id': ticketId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
